var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fund-test-accounts',{attrs:{"is-loading":_vm.isLoading,"funded-accounts":_vm.fundedAccounts,"project-name-by-id":_vm.projectNameById,"currencies":_vm.currencies},on:{"fund":_vm.onFundTestAccounts}})
}
var staticRenderFns = []

export { render, staticRenderFns }